"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _PaymentContext = _interopRequireDefault(require("../../context/PaymentContext"));
var _excluded = ["to", "children", "intl", "url"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AbsoluteLink = function AbsoluteLink(props) {
  var to = props.to,
    children = props.children,
    locale = props.intl.locale,
    url = props.url,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var updatedLocale = locale === 'ja' ? '/ja' : '';
  var tail = to || '';
  return _react["default"].createElement("a", (0, _extends2["default"])({
    href: "".concat(url).concat(updatedLocale).concat(tail)
  }, rest), children);
};
var AbsoluteLinkWithContext = function AbsoluteLinkWithContext(props) {
  var _context$tenant;
  var context = (0, _react.useContext)(_PaymentContext["default"]);
  return _react["default"].createElement(AbsoluteLink, (0, _extends2["default"])({
    url: context === null || context === void 0 || (_context$tenant = context.tenant) === null || _context$tenant === void 0 ? void 0 : _context$tenant.url
  }, props));
};
var _default = exports["default"] = (0, _reactIntl.injectIntl)(AbsoluteLinkWithContext);